import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IDVSDKComponent } from './idv-sdk/idv-sdk.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HeaderComponent } from './layouts/header/header.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { LoaderComponent } from './components/loader/loader.component';
import { icons, LucideAngularModule } from 'lucide-angular';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { MatIconModule } from '@angular/material/icon';
import { LibraryModule } from 'src/app/library/library.module';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';



@NgModule({
  declarations: [
    IDVSDKComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    ThankYouComponent
  ],
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    LibraryModule,
    LucideAngularModule.pick(icons)
  ],
  exports: [  
    IDVSDKComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    ThankYouComponent
  ]
})
export class SharedModule { }
